import api from './api';

let usernamesCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const usersService = {
  /**
   * Fetch usernames from stats endpoint with caching
   */
  async fetchUsernames(forceRefresh = false) {
    // Check cache validity
    if (!forceRefresh && usernamesCache && cacheTimestamp && 
        (Date.now() - cacheTimestamp < CACHE_DURATION)) {
      return usernamesCache;
    }

    try {
      const response = await api.get('/stats');
      const usernames = response.data.usernames || {};
      
      // Update cache
      usernamesCache = usernames;
      cacheTimestamp = Date.now();
      
      return usernames;
    } catch (error) {
      // Silently handle errors and return empty object or cached data
      if (usernamesCache) {
        return usernamesCache;
      }
      return {};
    }
  },

  /**
   * Get user fullname by ID
   */
  async getFullname(userId) {
    const usernames = await this.fetchUsernames();
    return usernames[userId] || '';
  },

  /**
   * Clear cache
   */
  clearCache() {
    usernamesCache = null;
    cacheTimestamp = null;
  }
};